import { LOCATION_CITIES, LOCATION_CITIES_WITH_LOCAL_BUSINESS_SCHEMA } from './locationCities';
import { SELL_YOUR_CAR_PATH } from './wordpress';

export const DEFAULT_LOCATION_PAGES_FOR_LOCAL_BUSINESS_SCHEMA = LOCATION_CITIES_WITH_LOCAL_BUSINESS_SCHEMA;

export const LOCATION_PAGES = LOCATION_CITIES;

export const SORTED_LOCATION_PAGES = [...LOCATION_PAGES].sort((a, b) => a.localeCompare(b));

export type LocationPage = (typeof LOCATION_PAGES)[number];

type IsLocationPageRouteProps = {
  includeAllLocationPages?: boolean;
  url: string;
};

const locationPageRegexAll = new RegExp(`^(${SELL_YOUR_CAR_PATH})/(${LOCATION_PAGES.join('|')})$`);
const locationPageRegexDefault = new RegExp(`^(${SELL_YOUR_CAR_PATH})/(${DEFAULT_LOCATION_PAGES_FOR_LOCAL_BUSINESS_SCHEMA.join('|')})$`);

export const isLocationPageRoute = (
  { includeAllLocationPages, url }: IsLocationPageRouteProps,
): boolean => (includeAllLocationPages ? locationPageRegexAll : locationPageRegexDefault).test(url);

const sellYourCarRegex = new RegExp(`^${SELL_YOUR_CAR_PATH}/(.+)$`);

export const extractCityFromLocationURL = (url?: string): LocationPage | null => {
  if (!url || typeof url !== 'string') {
    return null;
  }

  const match = sellYourCarRegex.exec(url);
  if (!match?.[1]) {
    return null;
  }

  const city = match[1] as LocationPage;
  return SORTED_LOCATION_PAGES.includes(city) ? city : null;
};
